const Help = (props) => {
  return (
    <div style={{ padding: "50px" }}>
      <div style={{ fontSize: "18pt" }}>ヘルプ画面</div>
    </div>
  );
};

export default Help;
